import * as React from 'react';
import {Link} from "react-router-dom";
import NotificationModal from "../modals/NotificationModal";

interface IProps {
    addressChangeUrl: string;
    allowAddressChange: boolean;
    futureMta: boolean;
    fullAddress: string;
    coverCancelled: boolean;
    mtaOnEndDateOfPolicy: boolean;
}

interface IState {
    showAlert: boolean;
}

export class AddressDetailsWidget extends React.Component<IProps, IState> {

    constructor(props: any) {
        super(props);

        this.state = {
            showAlert: false,
        }
    };

    public render(): React.ReactNode {
        const restrictAddressChange: boolean = !this.props.allowAddressChange || this.props.futureMta || this.props.coverCancelled || this.props.mtaOnEndDateOfPolicy;

        return (
            <div>
                <div className="panel-detail-output-entity account-details-title p-0">
                    <h2 className="inner-content dashboard-panel-title">Address</h2>
                </div>
                <div className="panel-detail-output-entity address-details">
                    <p id="full-address">{this.props.fullAddress}</p>
                </div>
                <div className="form-group pt-2">
                    <Link to={this.props.addressChangeUrl}
                        className="buttonLink"
                        onClick={this.handleClick}
                        id="editAddress">
                            <button type="button" className={"btn btn-blue-dashboard m-auto"}  disabled={restrictAddressChange}>
                                Edit address
                            </button>
                    </Link>
                </div>
                {this.renderAlert()}
            </div>
        )
    }

    private handleClick = (event: any): void => {
        const restrictAddressChange: boolean = !this.props.allowAddressChange || this.props.futureMta || this.props.coverCancelled || this.props.mtaOnEndDateOfPolicy;

        if (restrictAddressChange){
            event.preventDefault();
            this.setState({showAlert: true});
        }
    };

    private hideAlert = () => {
        this.setState({showAlert: false});
    }

    private renderAlert(): React.ReactNode {
        const wording: string = this.props.coverCancelled ?
            "Due to policy cancellation this action is not allowed" :
            "This action is not allowed";

        return (
            <NotificationModal show={this.state.showAlert} hide={this.hideAlert}>
                {wording}
            </NotificationModal>
        )
    }
}
